import React from 'react';
import { Container, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const RestrictedPage: React.FC = () => {
    return (
        <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
            <CancelIcon sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
            <Typography variant="h5" color="error" gutterBottom>
                Feature Restricted!
            </Typography>
            <Typography variant="body1">
                This feature is not available in your store.
            </Typography>
        </Container>
    );
};

export default RestrictedPage;
